const EpiappClientEvent = require('./EpiappClientEvent')

class EpiappClientFollowEvent extends EpiappClientEvent {
    constructor (props) {
        super(props)

        this.type = EpiappClientFollowEvent.TYPE

        this.launchQuery = props.launchQuery
        this.launchOriginalQuery = props.launchOriginalQuery

        this.followLinkAri = props.followLink.ari,
        this.followLinkName = props.followLink.name,
        this.followLinkUri = props.followLink.uri,
        this.followLinkType = props.followLink.type,
        this.followLinkSource = props.followLink.source,
        this.followLinkRelevance = props.followLink.relevance,
        this.followLinkTrust = props.followLink.trust,
        this.followLinkTrustScore = props.followLink.trustScore,
        this.followLinkScore = props.followLink.score

        this.followBackground = props.followBackground
        this.followIncognito = props.followIncognito
    }
}

EpiappClientFollowEvent.TYPE = 'epi:epiapp:client:follow:event'

module.exports = EpiappClientFollowEvent
